import type { SearchProductsQuery } from '@/types/api';

export const productKeys = {
  all: ['products'] as const,
  lists: () => [...productKeys.all, 'list'] as const,
  list: (query: SearchProductsQuery = {}) =>
    [...productKeys.lists(), query] as const,
  details: () => [...productKeys.all, 'detail'] as const,
  detail: (id: number) => [...productKeys.details(), id] as const,
  offSearch: (query: string) =>
    [...productKeys.all, 'off-search', query] as const,
};
